'use client'

import { useParams } from 'next/navigation'
import Image from 'next/image'
import { Image as DatoImage } from 'react-datocms'
import { Button, RightTopArrow } from '@desoutter/uikit'
import { HomeIndustryCardFragment } from './HomeIndustryCard.generated'
import { LocalizedLink } from '@/components/LocalizedLink'

type HomeIndustryCardProps = {
	fragment: HomeIndustryCardFragment
}

export default function HomeIndustryCard({ fragment }: HomeIndustryCardProps) {
	const { lang } = useParams()

	return (
		<LocalizedLink
			locale={lang}
			prefetch={false}
			href={`/industries/${fragment.industry.slug}`}
			title={fragment.industry.pageNameBo}
			className="relative group/link w-full flex"
		>
			<Image
				src="/images/linear-mask.png"
				alt="linear-mask"
				fill
				style={{ objectFit: 'cover' }}
				className="absolute bottom-0 w-full z-10 group-hover/link:brightness-125 duration-200 "
			/>
			<div className="overflow-hidden rounded-2xl flex flex-col h-[320px] relative sm:pr-0 text-white gap-5">
				<DatoImage
					layout="responsive"
					objectFit="cover"
					data={fragment.image.responsiveImage}
					className="w-full h-full group-hover/link:scale-105 duration-200"
				/>

				<Button
					size="xl"
					name="go to industry"
					color="tertiary"
					title="go to industry"
					icon={RightTopArrow}
					className="absolute top-8 right-8"
				/>

				<div className="absolute bottom-4 left-4 max-w-xs flex flex-col z-10 gap-2 group-hover/link:-translate-y-2 duration-200">
					<div className="h4">{fragment.industry.label}</div>
					<p className="line-clamp-3">{fragment.description}</p>
				</div>
			</div>
		</LocalizedLink>
	)
}
